import { useTranslation } from "../../../../hooks/useTranslation";
import { Button } from "../../../ui/button";
import { Nav } from "../../../ui/nav";
import { useLanguage } from "../../../../hooks/useLanguage";
import styles from './index.module.scss';

export const Desktop = () => {
    const { t } = useTranslation();
    const { switchLanguageHref } = useLanguage();

    return (
        <div className={styles.header}>
            <h3 onClick={() => {
                const el = document.getElementById('home');
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth' });
                }
            }}>Timothée Dumas</h3>
            <div className={styles.navigation}>
                <Nav onClick={() => {
                    const el = document.getElementById('solutions');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.solutions')}</Nav>
                <Nav onClick={() => {
                    const el = document.getElementById('experience');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.experiences')}</Nav>
                <Nav onClick={() => {
                    const el = document.getElementById('formation');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.education')}</Nav>
                <Nav onClick={() => {
                    const el = document.getElementById('portfolio');
                    if (el) {
                        el.scrollIntoView({ behavior: 'smooth' });
                    }
                }}>{t('header.portfolio')}</Nav>
                <Nav isLanguage={true} href={switchLanguageHref}>{t('header.language')}</Nav>
            </div>
            <Button
             onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}>
                <h4>{t('global.contact')}</h4>
            </Button>
        </div>
    );
};